import _ 				from "lodash";

import Service 			from "./../../Libs/Service";

import { Server } 		from "./Server";
import { Layout } 		from "./Layout";
import { User }			from "./User";
import { Version }		from "./Version";

let Project = new Service({

	Name: "Project",

	Libraries: [],

	Events: {

		"Clone Project Done": function(project_id) {

			this.selectProject(project_id);

		},

		"Versions Loaded": function(versions) {

			_.each(versions, version => {

				if (version) this.markProjectPartAsLoaded(version["project_id"], "versions");

			});

		},

		"Project Versions Loaded": function(projectId) {

			this.markProjectPartAsLoaded(projectId, "versions");

		},

		/*"Projects Version Assets Loaded": function(projectsVersionsAssets) {

			_.each(projectsVersionsAssets, (assets, projectId) => {

				this.markProjectPartAsLoaded(projectId, "assets");

			});

		},*/

		"Project Localization Loaded": function(projectId) {

			this.markProjectPartAsLoaded(projectId, "localization");

		},

		"Version Settings Loaded": function(projectsVersionsSettings) {

			_.each(projectsVersionsSettings, (versionsSettings, projectId) => {

				this.markProjectPartAsLoaded(projectId, "settings");

			});

		},

		"Version Settings Original Loaded": function(projectsVersionsSettings) {

			_.each(projectsVersionsSettings, (versionsSettings, projectId) => {

				this.markProjectPartAsLoaded(projectId, "settings-original");

			});

		},

		"Project Assets Loaded": function(projectId) {

			this.markProjectPartAsLoaded(projectId, "assets");

		},

		"Project Assets Original Loaded": function(projectId) {

			this.markProjectPartAsLoaded(projectId, "assets-original");

		},

		"Current User Changed,Current User Loaded": function() {

			if (!User.currentUser) {

				this.loadedProjects = {};
				this.Projects = {};
				this.ProjectsIconsTimes = {};
				this.SelectedProject = null;

				Broadcast.call("Selected Project Changed");

			}

		},
		"Layout Page Showed:banners,Layout Page Showed:playables,Layout Page Showed:end-cards,Layout Page Showed:marker": function() {

			this.autoSelectProject();

		}

	},

	Actions: {

		//Получение проектов текущего издателя
		"Projects": function(projects, data) {

			_.each(projects, (project, projectId) => {

				this.setProject(parseInt(projectId), project);

			});

			this.loaded = true;

			if (!Project.SelectedProject) this.autoSelectProject();

			if (data.ProjectsPublisherId) Broadcast.call("Publisher Projects Loaded", [data.ProjectsPublisherId]);

		},

		"NewProjectCreated": function(projectId) {

			this.selectProject(projectId);

			let project = this.Projects[projectId];
			if (project && project.type === 'banner') {
				if (!Version.VersionsByProject[projectId] || Object.values(Version.VersionsByProject[projectId]).length === 0) {
					Server.sendToSocket({
						CreateVersion: {
							projectId: projectId
						}
					});
				}

			}

		},

		"ProjectIconChanged": function(project_id) {

			this.ProjectsIconsTimes[project_id] = Date.now();

			Broadcast.call("Projects Icons Changed")

		},

		"CreativeDownloadLink": function(data) {

			if (data.releaseType) {

				Monitoring.unsetProcess({type: "release-build", name: `${data.versionId}-${data.releaseType}`});

			} else if (data.releasesTypes) {

				data.releasesTypes.forEach(releaseType => {

					Monitoring.unsetProcess({type: "release-build", name: `${data.versionId}-${releaseType}`});

				});

			}

			window.open(data.link, "blank");

		},

		"CreativeDownloadFailed": function(data) {

			Monitoring.setProcessError({type: "release-build", name: `${data.versionId}-${data.releaseType}`}, data);

		}

	},

	init() {

		this.loaded = false;

		this.loadedProjects = {};

		//Все проекты
		this.Projects = {};

		//Маркер изменения логотипа проекта чтобы сбросить кэш
		this.ProjectsIconsTimes = {};

		//Текущий проект
		this.SelectedProject = null;

	},

	setProject(project_id, newProject) {

		let oldProject = this.Projects[project_id];

		if (!newProject) {

			delete this.Projects[project_id];

			if (this.SelectedProject && this.SelectedProject.id === project_id) {

				this.SelectedProject = null;

			}

		} else {

			this.Projects[project_id] = newProject;

			if (newProject.options.templatePlayableCodename) newProject.templateProps = Metadata.TemplatePlayablesByCodename[newProject.options.templatePlayableCodename];
			if (newProject.options.endCardId) newProject.templateProps = Metadata.TemplateEndCards[newProject.options.endCardId];
			if (newProject.options.templateId) newProject.templateProps = Metadata.Templates[newProject.options.templateId];

			if (!newProject.options.markers) newProject.options.markers = [];

			newProject.engine = 'dom';
			if (newProject.Tags.pixi) newProject.engine = 'pixi';
			if (newProject.Tags.three) newProject.engine = 'three';

			if (this.SelectedProject && this.SelectedProject.id === project_id) this.SelectedProject = newProject;

		}

		this.detectProjectChanges(project_id, oldProject, newProject);

	},

	detectProjectChanges(projectId, oldProject, newProject) {

		//Если такой объект проекта уже был на клиенте
		if (oldProject) {

			//Если объект проекта пролучен
			if (newProject) {

				if (oldProject.title !== newProject.title) {

					if (newProject["id"] === Project.SelectedProject?.id) Broadcast.call("Selected Project Renamed");
					else Broadcast.call("Project Renamed", [projectId]);

				} else if (oldProject.options.markers.length !== newProject.options.markers.length) {

					if (newProject["id"] === Project.SelectedProject?.id) Broadcast.call("Selected Project Markers Changed");
					else Broadcast.call("Project Markers Changed", [projectId]);

				} else if (oldProject.tags !== newProject.tags) {

					if (newProject["id"] === Project.SelectedProject?.id) Broadcast.call("Selected Project Tags Changed");
					else Broadcast.call("Project Tags Changed", [projectId]);

				} else {

					if (newProject["id"] === Project.SelectedProject?.id) Broadcast.call("Selected Project Updated");
					else Broadcast.call("Project Updated", [projectId]);

				}

			}

			//Если проект удалили
			else {

				//Если это выбранный в данный момент проект
				if (oldProject["id"] === Project.SelectedProject?.id) {

					Broadcast.call("Selected Project Changed");

				} else {

					Broadcast.call("Project Changed", [projectId]);

				}

				Broadcast.call("Project Deleted", [projectId]);

			}

		}

		//Если такого объекта проекта ещё не было на клиенте
		else {

			//Если в новых пришедших данных есть объект проекта
			if (newProject) {

				//Broadcast.call(`Project Loaded`, [newProject["version_id"], newProject.codename]);
				Broadcast.call("Project Changed", [projectId]);

			}

			//Если проект удалили
			else {

				//Тут можно ничего не делаеть. Проекта и так не было, но пришло сообщение что его удалили

			}

		}

	},

	isSelectedProjectLoaded() {

		if (!this.SelectedProject) return false;

		return this.loadedProjects[this.SelectedProject.id] && this.loadedProjects[this.SelectedProject.id].loaded;

	},

	//Помечаем часть проекта как загруженную
	//И проверяем загружены ли все части, если да то помечаем весь проект как загруженный
	markProjectPartAsLoaded(projectId, partName) {

		let lp = this.loadedProjects[projectId];

		if (!lp) lp = this.loadedProjects[projectId] = {};

		lp[partName] = true;

		if (lp["versions"] && lp["assets"] && lp["assets-original"] && lp["localization"] && lp["settings"] && lp["settings-original"]) {

			let oldLoaded = lp.loaded;

			lp.loaded = true;

			if (!oldLoaded) {

				Broadcast.call("Project Fully Loaded", [projectId]);

				if (Project.SelectedProject && parseInt(projectId) === Project.SelectedProject.id) Broadcast.call("Selected Project Fully Loaded");
				//else console.log("Project Fully Loaded but NOT Selected", Project.SelectedProject, projectId);

			}

		}

	},

	selectProject(projectId) {

		if (this.Projects[projectId]) {

			this.SelectedProject = this.Projects[projectId];

			Layout.setProject(projectId);

			Broadcast.call("Selected Project Changed");

			window.localStorage.setItem("selected-project-id-for-publisher-" + Publisher.SelectedPublisher.id, projectId);

		} else {

			this.SelectedProject = null;

			Broadcast.call("Selected Project Changed");

		}

	},

	autoSelectProject() {

		if (!Publisher.SelectedPublisher) return;

		//Возможные проекты этого воркспейса
		let projects = this.getOrderedProjectsList(Publisher.SelectedPublisher, Layout.page, Layout.workspace, Layout.projectsFilter);

		//Последний открытый проект
		let lastProjectId = parseInt(window.localStorage.getItem("selected-project-id-for-publisher-" + Publisher.SelectedPublisher.id)) || 0;

		//Ищем его среди доступных проектов
		let lastProject = projects.find(project => {
			if (project.id === lastProjectId && this.Projects[lastProjectId] && this.Projects[lastProjectId].publisher_id === Publisher.SelectedPublisher.id) return true;
		});

		//Отменяем сброс проекта при переподключении к серверу и смене воркспейса
		if (lastProject && this.SelectedProject && this.Projects[this.SelectedProject.id] && this.Projects[this.SelectedProject.id].publisher_id === Publisher.SelectedPublisher.id) return;

		if (lastProjectId && lastProject) return this.selectProject(lastProjectId);

		if (projects[0]) this.selectProject(projects[0].id);
		else this.selectProject(null);

	},

	getOrderedProjectsList(publisher = null, page = null, workspace = null, searchFilter = null) {

		let sortData = {
			type: "create_date",
			order: "desc"
		};

		if (Publisher.SelectedPublisher?.options?.["UI"]?.["projectPlaneIconsSort"]) {
			const iconsSort = Publisher.SelectedPublisher.options["UI"]["projectPlaneIconsSort"];
			if (iconsSort.type) sortData.type = iconsSort.type;
			if (iconsSort.order) sortData.order = iconsSort.order;
		}

		let projects = _.values(Project.Projects);

		if (publisher) projects = _.filter(projects, p => p.publisher_id === publisher.id);

		if (page) {

			projects = _.filter(projects, p => (page === "playables" && p.type === "playable") || (page === "banners" && p.type === "banner") || (page === "end-cards" && p.type === "end-card") || (page === "marker" && _.intersection(_.get(p, `options.markers`), _.get(Layout, "pageOptions.markers")).length > 0));

			if (page !== "marker") projects = _.filter(projects, p => !p.options["showOnlyInMarkersMenu"]);

		}

		if (workspace) projects = _.filter(projects, p => p.Tags[`workspace-${workspace}`]);

		let projectWithSearchFilterId;
		if (searchFilter) {

			if (!isNaN(searchFilter.trim())) {
				projectWithSearchFilterId = _.find(projects, p => p.id === parseInt(searchFilter.trim()));
			}

			projects = _.filter(projects, p => p.title.toLowerCase().indexOf(searchFilter.toLowerCase()) > -1);
		}
		
		projects = _.filter(projects, p => User.currentUser?.Tags?.["admin"] || (!p.Tags["deleted"] && !p.Tags["hidden"]));

		let result = this.orderBy(projects, sortData.type, sortData.order);
		if (projectWithSearchFilterId && (User.currentUser?.Tags?.["admin"] || (!projectWithSearchFilterId.Tags["deleted"] && !projectWithSearchFilterId.Tags["hidden"]))) result = [projectWithSearchFilterId].concat(result);

		return result;

	},

	getTitle(project) {

		let title = project.title;
		let publisher = Publisher.Publishers[project["publisher_id"]];

		if (!publisher) return title;

		if (title.toLowerCase().indexOf(publisher.codename) === 0) title = title.substr(publisher.codename.length + 1);

		return title;

	},

	orderBy(collection, type, order) {

		if (type === "title") {

			collection.sort((a, b) => {

				let nameA= this.getTitle(a), nameB = this.getTitle(b);

				nameA = nameA.toLowerCase();
				nameB = nameB.toLowerCase();

				if (order === "asc") {
					if (nameA < nameB) return -1;
					if (nameA > nameB) return 1;
					return 0;
				} else if (order === "desc") {
					if (nameA < nameB) return 1;
					if (nameA > nameB) return -1;
					return 0;
				}

			});

			return collection;

		} else return _.orderBy(collection, type, order);

	},

	downloadCreative(type, networkOptions) {

		Server.sendToSocket({
			DownloadCreative: {
				projectId: Project.SelectedProject.id,
				versionId: Version.SelectedVersion.id,
				releaseType: type,
				networkOptions: networkOptions
			}
		});

		Monitoring.setProcess({type: "release-build", name: `${Version.SelectedVersion.id}-${type}`})

	}

});

//Делаем объект синглтоном чтобы при импортах возвращался тот же самый экземпляр
if (window.Project) Project = window.Project;
else window.Project = Project;

export { Project }

